const Photo = () => (
  <section className="photo">
    <div className="color_photo" />
  </section>
);

export default Photo;
